import React from 'react';
import '../index.scss';

const ResultsHeader = ({ count, searchTerm }) => {
  return (
    <div className="results-header">
      <h2 className="term-header">
        Search results for "{searchTerm}" in Conversations
      </h2>
      <div className="number-header">{count} results found</div>
    </div>
  );
};

export default ResultsHeader;
